import { createContext } from "react";
import type { ActiveMonitorsDrawerAPI } from "./types";

const ActiveMonitorsDrawerContext =
  createContext<ActiveMonitorsDrawerAPI | null>(null);
export default ActiveMonitorsDrawerContext;
